
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("6cq9R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $483827877ae635f5$var$_jquery = $483827877ae635f5$var$_interopRequireDefault((parcelRequire("eQYlV")));

var $h1D2Q = parcelRequire("h1D2Q");
function $483827877ae635f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $483827877ae635f5$var$$body = (0, $483827877ae635f5$var$_jquery["default"])("body");
var $483827877ae635f5$var$$mainmenuToggler = (0, $483827877ae635f5$var$_jquery["default"])("#mainmenu-toggler");
var $483827877ae635f5$var$$mainMenu = (0, $483827877ae635f5$var$_jquery["default"])("#mainmenu");
var $483827877ae635f5$var$$subnavToggler = (0, $483827877ae635f5$var$_jquery["default"])("#subnav-toggler");
var $483827877ae635f5$var$$subnav = (0, $483827877ae635f5$var$_jquery["default"])("#subnav");
var $483827877ae635f5$var$openMenu = function openMenu() {
    $483827877ae635f5$var$$body.addClass("menu-open");
    $483827877ae635f5$var$$mainMenu.slideDown();
};
var $483827877ae635f5$var$closeMenu = function closeMenu() {
    $483827877ae635f5$var$$body.removeClass("menu-open");
    $483827877ae635f5$var$$mainMenu.slideUp();
};
var $483827877ae635f5$var$openSubNav = function openSubNav() {
    $483827877ae635f5$var$$body.addClass("subnav-open");
    $483827877ae635f5$var$$subnav.slideDown();
};
var $483827877ae635f5$var$closeSubNav = function closeSubNav() {
    $483827877ae635f5$var$$body.removeClass("subnav-open");
    $483827877ae635f5$var$$subnav.slideUp();
};
var $483827877ae635f5$var$main = function main() {
    var menuItems = document.querySelectorAll(".nav-item.has-submenu .nav-link");
    if (menuItems.length === 0) return;
    menuItems.forEach(function(item) {
        item.addEventListener("click", function(e) {
            var parentItem = item.closest(".nav-item.has-submenu");
            var closeBtn = parentItem.querySelector(".close-btn");
            var submenu = parentItem.querySelector(".submenu-wrapper");
            // Collapse other items
            menuItems.forEach(function(otherItem) {
                var parentEl = otherItem.closest(".nav-item.has-submenu");
                var submenuWrapper = parentEl.querySelector(".submenu-wrapper");
                if (parentItem !== parentEl) {
                    parentEl.classList.remove("expanded");
                    if (window.innerWidth < 992) (0, $483827877ae635f5$var$_jquery["default"])(submenuWrapper).slideUp();
                }
            });
            if (parentItem.classList.contains("expanded")) {
                parentItem.classList.remove("expanded");
                if (window.innerWidth < 992) (0, $483827877ae635f5$var$_jquery["default"])(submenu).slideUp();
                return;
            } else if (window.innerWidth < 992) (0, $483827877ae635f5$var$_jquery["default"])(submenu).slideDown();
            parentItem.classList.add("expanded");
            if (closeBtn) closeBtn.addEventListener("click", function(e) {
                e.stopPropagation();
                parentItem.classList.remove("expanded");
            });
        });
    });
};
var $483827877ae635f5$var$init = module.exports.init = function init() {
    $483827877ae635f5$var$$mainmenuToggler.on("click", function(e) {
        e.preventDefault();
        if (!$483827877ae635f5$var$$body.hasClass("menu-open")) $483827877ae635f5$var$openMenu();
        else $483827877ae635f5$var$closeMenu();
    });
    document.addEventListener("click", function(e) {
        if ($483827877ae635f5$var$$body.hasClass("menu-open") && e.target.closest("#mainmenu") == null && e.target.closest("#mainmenu-toggler") == null) $483827877ae635f5$var$closeMenu();
    });
    $483827877ae635f5$var$$subnavToggler.click(function(e) {
        e.preventDefault();
        if (!$483827877ae635f5$var$$body.hasClass("subnav-open")) $483827877ae635f5$var$openSubNav();
        else $483827877ae635f5$var$closeSubNav();
    });
    document.addEventListener("click", function(e) {
        if ($483827877ae635f5$var$$body.hasClass("subnav-open") && e.target.closest("#subnav") == null && e.target.closest("#subnav-toggler") == null) $483827877ae635f5$var$closeSubNav();
    });
    (0, $483827877ae635f5$var$_jquery["default"])(window).on("load resize", function() {
        var windowWidth = window.innerWidth;
        if (windowWidth >= 992) {
            $483827877ae635f5$var$$body.removeClass("subnav-open");
            $483827877ae635f5$var$$mainMenu.removeAttr("style");
            (0, $483827877ae635f5$var$_jquery["default"])(".subnav .has-submenu").removeClass("open");
            (0, $483827877ae635f5$var$_jquery["default"])(".subnav .has-submenu > ul").removeAttr("style");
            (0, $483827877ae635f5$var$_jquery["default"])(".submenu-wrapper").removeAttr("style");
        } else {
            $483827877ae635f5$var$$body.removeClass("menu-open");
            $483827877ae635f5$var$$mainMenu.removeAttr("style");
            (0, $483827877ae635f5$var$_jquery["default"])(".submenu-wrapper").removeAttr("style");
        }
    });
    var $subItemsTogglers = (0, $483827877ae635f5$var$_jquery["default"])(".subnav .has-submenu > a > .ai");
    $subItemsTogglers.on("click", function(e) {
        e.preventDefault();
        var windowWidth = window.innerWidth;
        if (windowWidth < 992) {
            var $parentItem = (0, $483827877ae635f5$var$_jquery["default"])(this).closest(".has-submenu");
            var isOpen = $parentItem.hasClass("open");
            (0, $483827877ae635f5$var$_jquery["default"])(".subnav .has-submenu").removeClass("open");
            (0, $483827877ae635f5$var$_jquery["default"])(".subnav .has-submenu > ul").slideUp();
            if (!isOpen) {
                $parentItem.addClass("open");
                $parentItem.find(" > ul").slideDown();
            } else {
                $parentItem.removeClass("open");
                $parentItem.find(" > ul").slideUp();
            }
        }
    });
    // Close menu and search when modal is open
    var $modalBtns = (0, $483827877ae635f5$var$_jquery["default"])('[data-bs-toggle="modal"]');
    $modalBtns.each(function(index) {
        (0, $483827877ae635f5$var$_jquery["default"])(this).on("click", function(e) {
            if ($483827877ae635f5$var$$body.hasClass("search-open")) {
                (0, $483827877ae635f5$var$_jquery["default"])("body").removeClass("search-open");
                (0, $483827877ae635f5$var$_jquery["default"])("#search").slideUp();
            }
            if ($483827877ae635f5$var$$body.hasClass("menu-open")) {
                (0, $483827877ae635f5$var$_jquery["default"])("body").removeClass("menu-open");
                (0, $483827877ae635f5$var$_jquery["default"])("#mainmenu").slideUp();
            }
        });
    });
    /*---------sticky header---------*/ function updateStickyHeader() {
        if (window.scrollY >= 50) document.body.classList.add("sticky-header");
        else document.body.classList.remove("sticky-header");
        if (window.innerWidth < 992) document.body.classList.add("sticky-header");
    }
    (0, $483827877ae635f5$var$_jquery["default"])(window).on("resize scroll", updateStickyHeader);
    updateStickyHeader();
    /*---------/sticky header ---------*/ (0, $h1D2Q.domReady)().then(function() {
        return $483827877ae635f5$var$main();
    });
};

});
parcelRegister("h1D2Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.domReady = void 0;
var $c650d1302b554f6f$var$domReady = module.exports.domReady = function domReady() {
    return new Promise(function(resolve) {
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", resolve, {
            once: true
        });
        else resolve();
    });
};

});



//# sourceMappingURL=flyout.module.cb3925fc.js.map
